const Vue = require('vue')

Vue.component('ui-confirm', require('components/ui/Confirm.vue'))



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui/confirm.js